const US_NUMERIC_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

/** Parses the `M/D/YYYY` strings that `DateRangeInput` writes via
 *  `toLocaleDateString("en-US")` back into a local-time `Date`. Returns
 *  undefined for anything else, including impossible calendar dates. */
export const parseUsDate = (value: string): Date | undefined => {
	const match = US_NUMERIC_DATE.exec(value);
	if (!match) {
		return undefined;
	}
	const [month, day, year] = match.slice(1).map(Number);
	const date = new Date(year, month - 1, day);
	const isSameCalendarDay =
		date.getFullYear() === year &&
		date.getMonth() === month - 1 &&
		date.getDate() === day;
	return isSameCalendarDay ? date : undefined;
};
